// Query-key root for the datasets shown in the Data Correction view. It is passed to
// `useDatasets` as the `datasetRefreshToken` and used to invalidate those datasets after an
// edit, so both sides must agree on it — hence a shared constant rather than a literal.
export const EDIT_TIME_SERIES_DATASET_QUERY_KEY = 'edit_time_series_dataset'

export const CREATE_DATA_POINTS_ENDPOINT = 'edit_timeseries/create_data_points'
